import { render, staticRenderFns } from "./tabYFZDGL.vue?vue&type=template&id=4db7d392&scoped=true&"
import script from "./tabYFZDGL.vue?vue&type=script&lang=js&"
export * from "./tabYFZDGL.vue?vue&type=script&lang=js&"
import style0 from "./tabYFZDGL.vue?vue&type=style&index=0&id=4db7d392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7d392",
  null
  
)

export default component.exports